export default __webpack_public_path__ + "0db9bc73e6b077db1017f411fa72605b.svg";